import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-help-button',
    imports: [MatButtonModule, MatIconModule, MatMenuModule],
    templateUrl: './help-button.component.html',
    standalone: true,
})
export class HelpButtonComponent { }
